// @flow
import { defaultToEmptyString } from '@alphaott/common-utils'
import { makeGetRequest, makeDeleteRequest } from './utils'

import type { ResponseAPI, Headers } from './types/api'
import type { Devices } from './types/devices'

type Options = { ...Headers, id: string }

export const getDevices = (domain: string, { token }: Headers): Promise<ResponseAPI<Devices>> =>
  makeGetRequest(`${domain}/client/api/customer/devices`, { headers: { token } })

export const removeDevice = (domain: string, { token, id }: Options): Promise<ResponseAPI<Devices>> =>
  makeDeleteRequest(`${domain}/client/api/customer/device/${defaultToEmptyString(id)}`, {
    headers: { token },
  })

export const getPublicIp = (domain: string): Promise<ResponseAPI<Devices>> =>
  makeGetRequest(`${domain}/client/api/location`)

export default getDevices
